import { useNavigation } from '@react-navigation/native'
import React, { useCallback, useEffect } from 'react'
import { useSnapshot } from 'valtio'

import { useAuth } from '../../context/auth'
import { useAppStatus } from '../../hooks/use-app-status'

import { LogoutDialog } from './LogoutDialog'

type LogoutWarningProps = { reset: () => void }

export function LogoutWarning({ reset }: LogoutWarningProps) {
  const { isLoggedIn, isLoading, logout } = useAuth()
  const { status, setInactivityStatus } = useAppStatus()
  const navigation = useNavigation()
  const handleLogout = () => setInactivityStatus({ forceLogout: true })
  const handleTimerExpired = () => setInactivityStatus({ timerExpired: true })
  const { isIdle, forceLogout, timerExpired } = useSnapshot(status.inactivityStatus)

  const logoutAndRedirect = useCallback((reason?: string) => {
    logout()
      .catch(err => console.error('🔴 Error logging out:', err))
      .finally(() => navigation.navigate('AuthRedirect', { reason }))
  }, [])

  useEffect(() => {
    if (!isLoggedIn) return
    if (forceLogout) return logoutAndRedirect()
    if (timerExpired) return logoutAndRedirect('inactivity')
  }, [forceLogout, isLoggedIn, logoutAndRedirect, timerExpired])

  if (isLoggedIn && isIdle) {
    return (
      <LogoutDialog
        isLoading={isLoading}
        onLogout={handleLogout}
        onStaySignedIn={reset}
        onTimerExpired={handleTimerExpired}
      />
    )
  }

  return null
}
